import { Container } from "@repo/ui/core";
import type { ReactNode } from "react";
import { Reveal } from "@/components/Reveal";
import styles from "@styles/site.module.css";

type PageHeroProps = {
  eyebrow: string;
  title: ReactNode;
  description: string;
  children?: ReactNode;
};

export function PageHero({ eyebrow, title, description, children }: PageHeroProps) {
  return (
    <div className={styles.pageHero}>
      <Container size="xl" className={styles.pageHeroInner}>
        <Reveal>
          <span className={styles.eyebrow}>{eyebrow}</span>
        </Reveal>
        <Reveal delay={0.06}>
          <h1 className={styles.pageTitle} style={{ marginTop: 18 }}>
            {title}
          </h1>
        </Reveal>
        <Reveal delay={0.12}>
          <p className={styles.pageSubtitle} style={{ marginTop: 18 }}>
            {description}
          </p>
        </Reveal>
        {children && (
          <Reveal delay={0.18}>
            <div style={{ marginTop: 28, display: "flex", gap: 12, flexWrap: "wrap" }}>{children}</div>
          </Reveal>
        )}
      </Container>
    </div>
  );
}
